<script>
    export default {
        name: 'base-date-time-input',

        props: {
            dateConfig: {
                type: Object,
                default() {
                    return {};
                },
            },

            timeConfig: {
                type: Object,
                default() {
                    return {};
                },
            },

            disabled: {
                type: [String, Boolean],
                default() {
                    return false;
                },
            },

            rental: {
                type: String,
                default() {
                    return '';
                },
            },

            date: {
                type: String,
                default() {
                    return '';
                },
            },

            time: {
                type: String,
                default() {
                    return '';
                },
            },
        },

        computed: {
            dateVal: {
                get() {
                    return this.date;
                },

                set(val) {
                    this.$emit('update:date', val);
                },
            },

            timeVal: {
                get() {
                    return this.time;
                },

                set(val) {
                    this.$emit('update:time', val);
                },
            },
        },
    };
</script>
